import { createContext } from "react";

const HTTPClientContext = createContext();

export default HTTPClientContext;
